module.exports = __webpack_public_path__ + "media/application/images/svgs/mail-d6fb37beb6f7fd2f8fc0aad3d7963a72.svg";